export default __webpack_public_path__ + "static/media/Falchion of the Arena Master.ea59f94f.jpg";